export default {
	title: "Display / TV",
	subtitle: "Gestione mensajes y vídeos mostrados en la TV del templo",
	newMessage: "Nuevo Mensaje",
	editMessage: "Editar Mensaje",
	messageTitle: "Título",
	content: "Contenido",
	type: "Tipo",
	types: {
		TEXT: "Texto",
		VIDEO: "Vídeo",
	},
	videoUrl: "URL del Vídeo (YouTube)",
	showInQueue: "Mostrar en cola (pie de pantalla de la TV)",
	sortOrder: "Orden",
	active: "Activo",
	inactive: "Inactivo",
	totalMessages: "Total",
	controls: {
		title: "Control del Display",
		sendMessage: "Enviar Mensaje",
		playVideo: "Reproducir Vídeo",
		clearDisplay: "Limpiar Display",
	},
	messages: {
		created: "Mensaje creado con éxito",
		updated: "Mensaje actualizado con éxito",
		deleted: "Mensaje eliminado con éxito",
		sent: "Mensaje enviado al display",
		videoSent: "Vídeo enviado al display",
		cleared: "Display limpiado",
		confirmDelete: "¿Está seguro de que desea eliminar este mensaje?",
	},
	oriTv: {
		title: "App ORI TV",
		description: "Instale la app ORI TV en su Fire TV Stick o Android TV para mostrar llamadas de fichas, mensajes y vídeos en la pantalla del templo.",
		step1: "Descargue e instale el APK en el dispositivo (Fire TV Stick, Android TV o tablet)",
		step2: "Abra la app y acceda a la dirección mostrada en pantalla para autorizar",
		step3: "¡Listo! Las fichas y mensajes aparecerán automáticamente en la TV",
		download: "Descargar ORI TV (.apk)",
		compatibility: "Compatible con Fire TV Stick, Android TV y tablets Android",
		version: "Versión",
	},
	deviceAuth: {
		title: "Autorizar Dispositivo",
		subtitle: "Conecte una TV o dispositivo al templo",
		enterCode: "Introduzca el código mostrado en la TV",
		selectTemple: "Seleccionar Templo",
		authorize: "Autorizar Dispositivo",
		success: "¡Dispositivo autorizado con éxito!",
		successDesc: "La TV ya puede mostrar las fichas de su templo.",
		error: "Error al autorizar dispositivo",
	},
};
